import type { FC } from 'react';
import { DrawerSection } from '@components/DrawerSection';
import IconMdi from '@components/IconMdi';
import { Show, ShowFirstMatching } from '@components/Show';
import { mdiAlert } from '@mdi/js';

import { useBlockPanelContent } from '../hooks/useBlockPanelContent';

interface DrawerBlockStatusProps {
  isArchived?: boolean;
  isBlock: boolean;
  isInactive: boolean;
  isNotYetActive: boolean;
}

export const DrawerBlockStatus: FC<DrawerBlockStatusProps> = ({ isBlock, isInactive, isArchived, isNotYetActive }) => {
  const { getContent } = useBlockPanelContent(isBlock);

  if (!isInactive && !isArchived && !isNotYetActive) {
    return null;
  }

  return (
    <DrawerSection title={getContent('fields.status.label')}>
      <div className="text-error-900 flex cursor-default items-start gap-1 text-sm">
        <ShowFirstMatching>
          <Show when={isArchived}>
            <IconMdi centerVertical={false} path={mdiAlert} />
            {getContent('fields.status.archived')}
          </Show>
          <Show when={isNotYetActive}>
            <IconMdi centerVertical={false} path={mdiAlert} />
            {getContent('fields.status.notYetActive')}
          </Show>
          <Show when={isInactive}>
            <IconMdi centerVertical={false} path={mdiAlert} />
            {getContent('fields.status.inactive')}
          </Show>
        </ShowFirstMatching>
      </div>
    </DrawerSection>
  );
};
